import React from 'react';
import autoBind from 'react-autobind';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import noty from '../../lib/noty';
import Field from '../Field';

/**
 * A modal dialog can only be closed by selecting one of the actions.
 */
export default class GroupModal extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      loaded: false,
      fetching: false,
      touched: false,
      group: this.props.group
    };
  }

  handleClose() {
    if (this.state.touched) {
      noty.confirm(
        `Are you sure you want to leave? You have unsaved changes.`,
        { onOk: () => this.props.onRequestClose() }
      );
    } else {
      this.props.onRequestClose();
    }
  }

  handleSave() {
    const { group } = this.state;
    const method = group._id ? 'patch' : 'create';
    this.setState({ fetching: true });
    group[method]()
      .then(() => {
        method === 'patch'
          ? noty.success('Group updated.')
          : noty.success('Group created.');
        this.props.onRequestClose();
      })
      .catch(err => {
        noty.errors(err);
        this.setState({ fetching: false });
      });
  }

  handleDelete() {
    noty.confirm(`Are you sure you want to delete this group?`, {
      onOk: () => {
        this.setState({ fetching: true });
        this.state.group
          .remove()
          .then(() => {
            noty.success('Group deleted.');
            this.props.onRequestClose();
          })
          .catch(err => {
            noty.errors(err);
            this.setState({ fetching: false });
          });
      }
    });
  }

  promptDelete() {
    noty.confirm(
      `You cannot delete this group because there are users associated with
      it. Remove all users from the "${
        this.state.group.name
      }" group before deleting.`,
      { onOk: () => {}, alert: true }
    );
  }

  handleChange({ name, value }) {
    const path = name.split('.');
    this.setState({
      touched: true,
      group: this.state.group.setIn(path, value)
    });
  }

  render() {
    const { fetching } = this.state;
    const actions = [
      <FlatButton
        label="Cancel"
        primary
        disabled={fetching}
        onClick={this.handleClose}
      />,
      <FlatButton
        label="Save"
        primary
        disabled={fetching}
        onClick={this.handleSave}
      />
    ];

    if (this.state.group._id) {
      actions.push(
        <FlatButton
          label="Delete"
          onClick={
            !this.props.totalCount ? this.handleDelete : this.promptDelete
          }
          style={{ float: 'left', color: '#999' }}
          disabled={fetching}
        />
      );
    }

    return (
      <div>
        <RaisedButton label="New Group" onClick={this.handleOpen} />
        <Dialog title="Group" actions={actions} modal open>
          <Field
            name="name"
            value={this.state.group.name}
            onChange={this.handleChange}
            label="Group Name"
            disabled={fetching}
          />
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GroupModal/index.jsx